<template>
  <div style="margin-top: 10px">
    <div v-show="!showdetail">
      <div
        class="infinite-list-wrapper,tb-edit"
        style="overflow: auto"
        v-show="!mydis"
      >
        <el-table
          :data="tableData"
          border
          @row-dblclick="rowdbclk"
          show-summary
          :summary-method="getmysummaries"
        >
          <el-table-column prop="bcheck" label="选择" width="60">
            <template slot-scope="scope">
              <el-checkbox
                fixed="left"
                v-model="scope.row.bcheck"
                @change="CheckChange"
              ></el-checkbox>
            </template>
          </el-table-column>
          <el-table-column
            prop="skuno"
            label="书号"
            width="150"
          ></el-table-column>
          <el-table-column
            prop="skuname"
            label="书名"
            width="400"
          ></el-table-column>
          <el-table-column
            prop="sauthor"
            label="作者"
            width="200"
          ></el-table-column>
          <el-table-column
            prop="ssprice"
            label="价格"
            width="100"
          ></el-table-column>
          <el-table-column
            prop="spubname"
            label="版别"
            width="200"
            v-if="true"
          ></el-table-column>

          <el-table-column prop="inum" label="数量" width="200">
            <template slot-scope="scope">
              <el-input-number
                fixed="left"
                v-model="scope.row.inum"
                @change="inumChange(scope.row)"
                :min="1"
                :max="10000"
                label="增减"
              ></el-input-number>
            </template>
          </el-table-column>
          <el-table-column
            prop="namount"
            label="金额"
            width="100"
          ></el-table-column>
          <el-table-column label="操作" width="100">
            <template slot-scope="scope">
              <el-button
                @click="showorderitmedetail(scope.row)"
                type="text"
                size="small"
                >商品详情</el-button
              >

              <el-button
                @click="removeshopcart(scope.row)"
                type="text"
                size="small"
                >移除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <div style="margin-top: 20px">
          <el-button @click="clearcart()">清空购物车</el-button>
          <el-button @click="submitorder()">提交订单</el-button>
        </div>
      </div>

      <div v-show="mydis">
        <img src="/wait.gif" width="100%" />
      </div>
    </div>

    <div v-if="showdetail">
      <div style="text-align: left">
        <el-button
          type="primary"
          plain
          @click="gomain()"
          style="font-size: 16px"
          >返回</el-button
        >
      </div>

      <div>
        <skudetail :skupackobj="skuobj"></skudetail>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import global from "../global.vue";
import AES from "../AES.js";
import skudetail from "@/components/skudetail.vue";

export default {
  components: {
    skudetail,
  },

  data() {
    return {
      showdetail: false,
      tableData: [],
      mydis: false,
      setupsummary: [
        [1, "总计"],
        [6, "sumby", "个", 0],
        [7, "sumby", "元", 0],
        //第二个元素为“sum”的直接累计；为“sumby”的和第四个元素对应的字段的相乘后累计
      ],
    };
  },
  computed: {},
  created() {
    this.getdata();
  },
  methods: {
    showorderitmedetail(row) {
      //和orderdetail重复了，后面要整合一下。 caix20220411

      console.log(row);
      console.log(row.skuid);

      var squery =
        '{"query": {"term": {"skuid.keyword": "' +
        row.skuid +
        '"}},"from": 0, "size": 10000}';
      var oquery = JSON.parse(squery);
      var stoken = window.localStorage.getItem("stoken");

      let that = this;

      axios({
        headers: { "Content-type": "application/json", token: stoken },
        method: "post",
        url: global.sserverip + "getSkuByFilterFromES",
        data: oquery,
      })
        .then(function (res) {
          //TO-DO 先判断下数据是否正确 status
          console.log(res.data);
          var otmp = res.data.hits.hits[0]._source;
          console.log(otmp);
          otmp.supdateDate = global.dateFormat(
              otmp.updateDate,
              "yyyy-mm-dd hh:mm:ss"
            );
          that.skuobj = otmp;
          that.showdetail = true;
        })
        .catch(function (err) {
          console.log(err);
        });
    },
    gomain() {
      this.showdetail = false;
    },
     //表格统计项的设置，主要是setupsummary这个参数的设置
    getmysummaries(param) {
      return global.getcxSummaries(this.setupsummary, param);
    },
    clearcart() {
      var scustomerid = AES.decrypt(
        window.localStorage.getItem("scustomerid"),
        global.AEScode
      );
      var sbody =
        '{"query": {"term": {"scustomerid.keyword" : "' + scustomerid + '"}}}';
      var obody = JSON.parse(sbody);

      var stoken = window.localStorage.getItem("stoken");

      axios({
        // headers: {
        //   "Content-type": "application/json",
        // },
        // method: "post",
        // url: global.sskucartip + "/_delete_by_query",
        headers: { "Content-type": "application/json", token: stoken },
        method: "post",
        url: global.sserverip + "deleteShopcartByQueryFromES",
        data: obody,
      })
        .then(function (res) {
          //TO-DO 先判断下数据是否正确 status
          console.log(res);
          setTimeout(function () {
            location.assign(global.swebip + "qtindex/shoppingcart");
          }, 1000);
        })
        .catch(function (err) {
          console.log(err);
        });
    },

    submitorder() {
      console.log("reqbody");
      this.mydis = true;
      var reqbody = new Object();
      reqbody.stoken = window.localStorage.getItem("stoken");
      var orderitemlist = [];
      var arraylength = this.tableData.length;
      var i = 0;
      for (i = 0; i < arraylength; i++) {
        if (this.tableData[i].bcheck) {
          orderitemlist.push(this.tableData[i]);
        }
      }
      reqbody.item = orderitemlist;

      console.log(reqbody);
      // console.log(reqbody);
      // console.log(JSON.stringify(reqbody));

      var stoken = window.localStorage.getItem("stoken");
      // axios.defaults.headers.common["token"] = stoken;

      axios({
        headers: {
          "Content-type": "text/xml",
          token: stoken,
        },
        method: "post",
        url: global.sserverip + "putorder",
        data: reqbody,
      })
        .then(function (res) {
          //TO-DO 先判断下数据是否正确 status
          console.log(res);
          location.assign(global.swebip + "qtindex/orderlist");

          /*
setTimeout(function(){  //使用  setTimeout（）方法设定定时2000毫秒
// window.location.reload();//页面刷新
},1000);
 */
        })
        .catch(function (err) {
          console.log(err);
          this.mydis = false;
        });
      //应改为跳转到新订单页面，目前先刷新
    },
    CheckChange() {
      // console.log(this.tableData);
    },
    rowdbclk() {
      //后面可能要用
    },
    inumChange(row) {
      row.namount = (row.inum * row.ssprice).toFixed(2);
      console.log(row);
      var sid = row.id;
      let that = this;
      // console.log(global.sskucartip + "/" + sid + "/_update/");

      var stoken = window.localStorage.getItem("stoken");
      var reqbody = new Object();
      reqbody.field1 = sid;
      reqbody.field2 = JSON.stringify(row);

      axios({
        // headers: {"Content-type": "application/json",},
        // method: "PUT",
        // url: global.sskucartip + "/" + sid,
        // data: row,

        headers: { "Content-type": "application/json", token: stoken },
        method: "post",
        url: global.sserverip + "updateShopcartToES",
        data: JSON.stringify(reqbody),
      })
        .then(function (res) {
          //TO-DO 先判断下数据是否正确 status
          console.log(res);
        })
        .catch(function (err) {
          console.log(err);
        });
    },
    getdata() {
      let that = this;
      var scustomerid = AES.decrypt(
        window.localStorage.getItem("scustomerid"),
        global.AEScode
      );
      var squery =
        '{"query": {"term": {"scustomerid.keyword": "' +
        scustomerid +
        '"}},"from": 0, "size": 10000}';
      var oquery = JSON.parse(squery);

      var stoken = window.localStorage.getItem("stoken");

      axios({
        // headers: {
        //   "Content-type": "application/json",
        // },
        // method: "post",
        // url: global.sskucartip + "/_search",
        headers: { "Content-type": "application/json", token: stoken },
        method: "post",
        url: global.sserverip + "getShopcartByQueryFromES",
        data: oquery,
      })
        .then(function (res) {
          //TO-DO 先判断下数据是否正确 status
          console.log(res.data);
          var oresdata = [];
          var otmp = res.data.hits.hits;
          var x;
          for (x in otmp) {
            oresdata[x] = otmp[x]._source;
            oresdata[x].id = otmp[x]._id;
            oresdata[x].bcheck = true;
            oresdata[x].namount = (
              oresdata[x].inum * oresdata[x].ssprice
            ).toFixed(2);
          }
          that.tableData = oresdata;
        })
        .catch(function (err) {
          console.log(err);
        });
    },
    removeshopcart(row) {
      var stoken = window.localStorage.getItem("stoken");
      var sid = row.id;
      axios({
        // headers: {
        //   "Content-Type": "text/xml",
        // },
        // method: "DELETE",
        // url: global.sskucartip + "/" + sid,

        headers: { "Content-type": "application/json", token: stoken },
        method: "post",
        url: global.sserverip + "deleteShopcartByIDFromES",
        data: sid,
      })
        .then(function (res) {
          //TO-DO 先判断下数据是否正确 status
          console.log(res);
          // this.getdata();
          // location.reload();

          setTimeout(function () {
            //使用  setTimeout（）方法设定定时2000毫秒

            window.location.reload(); //页面刷新
          }, 500);
        })
        .catch(function (err) {
          console.log(err);
        });
    },
  },
};
</script>


<style>
.infinite-list-wrapper {
  max-height: 400px;
  /* max-height: 400px; 没有这项会自动加载到最大 */
}
</style>